export const selectCurrentUser = (state) => state.user.currentUser;

export default selectCurrentUser;
